<div class="card mb-4">
  <div class="card-body">
    <!-- create button  -->
<!-- Add button -->
<button
  (click)="openAddDialog()"
  role="button"
  
  class="btn btn-outline-success btn-icon-split"
>
  <span class="icon text-success">
    <i class="fas fa-plus"></i>
  </span>
  <span class="text">{{ categoryI18n?.addButtonI18n }}</span>
</button>

<!-- Summary button -->
<button
  href="#"
  role="button"
  class="btn btn-outline-secondary btn-icon-split"
  (click)="showChart()"
>
  <span class="icon text-secondary">
    <i class="fas fa-chart-line"></i>
  </span>
  <span class="text">{{ categoryI18n?.analyticsI18n }}</span>
</button>

<!-- Refresh button -->
<button
  href="#"
  role="button"
  class="btn btn-outline-warning btn-icon-split"
  (click)="reloadPage()"
>
  <span class="icon text-warning">
    <i class="fas fa-redo"></i>
  </span>
  <span class="text">{{ categoryI18n?.reloadI18n }}</span>
</button>


    <br /><br />

    <div *ngIf="showsummary">
      <ngx-charts-bar-vertical
        [view]="view"
        [scheme]="colorScheme"
        [results]="data"
        [gradient]="gradient"
        [xAxis]="showXAxis"
        [yAxis]="showYAxis"
        [legend]="showLegend"
        [showXAxisLabel]="showXAxisLabel"
        [showYAxisLabel]="showYAxisLabel"
        [xAxisLabel]="xAxisLabel"
        [yAxisLabel]="yAxisLabel"
        (select)="onSelect($event)"
      ></ngx-charts-bar-vertical>
    </div>
  </div>
</div>


<!-- category-statistics.component.html -->

<div class="container mt-5">

  <div class="row">
      <div class="col-md-4 mb-4">
          <div class="card text-center border">
              <div class="card-body">
                  <h5 class="card-title text-dark">Tổng Số Danh Mục</h5>
                  <p class="card-text h1">
                      <span *ngIf="count">{{ count }}</span>
                      <span *ngIf="!count">Đang tải...</span>
                  </p>
              </div>
          </div>
      </div>

      <div class="col-md-4 mb-4">
          <div class="card text-center border">
              <div class="card-body">
                  <h5 class="card-title text-success">Danh Mục Đã Xuất Bản</h5>
                  <p class="card-text h1">
                      <span *ngIf="status">{{ status.published }}</span>
                      <span *ngIf="!status">Đang tải...</span>
                  </p>
              </div>
          </div>
      </div>

      <div class="col-md-4 mb-4">
          <div class="card text-center border">
              <div class="card-body">
                  <h5 class="card-title text-danger">Danh Mục Chưa Xuất Bản</h5>
                  <p class="card-text h1">
                      <span *ngIf="status">{{ status.unpublished }}</span>
                      <span *ngIf="!status">Đang tải...</span>
                  </p>
              </div>
          </div>
      </div>
  </div>
</div>

